import { functions } from '@/plugins/firebase';
import * as doronServices from '@/services/doronServices';

export default {
  namespaced: true,
  state: {
    initialized: false,
    amount: 0,
    freeAmount: 0
  },
  mutations: {
    updateDoronAmount(state, payload) {
      state.amount = payload.amount;
      state.freeAmount = payload.freeAmount;
    }
  },
  actions: {
    async initStore({ commit }, userId) {
      const doronDoc = await doronServices.getDoronDoc(userId);
      if (!doronDoc) {
        return;
      }
      commit('updateDoronAmount', doronDoc);
    },
    async purchaseDoron({ commit, state }, payload) {
      const createChargeMethod = functions.httpsCallable('paymentCreateCharge');
      try {
        // create Charge on PAY.jp
        await createChargeMethod(payload);
        // update doron db
        console.log(state.freeAmount, payload.freeAmount);
        const result = await doronServices.updateDoronDoc(payload.userId, {
          amount: Number(state.amount) + Number(payload.amount),
          freeAmount: Number(state.freeAmount) + Number(payload.freeAmount)
        });
        // console.log(result);

        // commit state
        commit('updateDoronAmount', result);
      } catch (err) {
        console.error(err);
        return;
      }
    }
  },
  getters: {
    doronAmount(state) {
      return state.amount;
    }
  }
};
